import { render, staticRenderFns } from "./TimelineCronico.vue?vue&type=template&id=4b2bc2e0&scoped=true&lang=pug"
import script from "./TimelineCronico.vue?vue&type=script&lang=js"
export * from "./TimelineCronico.vue?vue&type=script&lang=js"
import style0 from "./TimelineCronico.vue?vue&type=style&index=0&id=4b2bc2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bc2e0",
  null
  
)

export default component.exports